import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LockKey } from "@phosphor-icons/react";
import logo from "@/assets/360view-logo.jpg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      const to = loc.state?.from || "/admin";
      nav(to, { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-16">
      <div className="w-full max-w-md border border-chrome bg-steel p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="bg-white p-1"><img src={logo} alt="360 View LLC" className="h-12 w-auto block" /></div>
          <div>
            <div className="font-display font-black text-white text-lg">360 VIEW LLC</div>
            <div className="eyebrow text-[10px] text-solar">Admin Console</div>
          </div>
        </div>
        <h2 className="mb-2 text-2xl">Sign in</h2>
        <p className="text-white/60 text-sm mb-6">Access the admin dashboard.</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <div className="eyebrow text-white/70 mb-1.5">Email</div>
            <input data-testid="login-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="w-full bg-obsidian border border-chrome px-4 py-3 text-white text-sm focus:border-solar outline-none" />
          </label>
          <label className="block">
            <div className="eyebrow text-white/70 mb-1.5">Password</div>
            <input data-testid="login-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="w-full bg-obsidian border border-chrome px-4 py-3 text-white text-sm focus:border-solar outline-none" />
          </label>
          {error && <div data-testid="login-error" className="text-red-400 text-sm">{error}</div>}
          <button data-testid="login-submit-btn" disabled={busy} className="btn-solar w-full disabled:opacity-60 flex items-center justify-center gap-2">
            <LockKey size={16} weight="fill" /> {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
